<div class="profile-image-container">
  <img [src]="imageUrl() || 'images/profile/no_avatar.png'"
      alt="avatar"
      height="150"
      width="150"
      class="profile-image"
      (click)="fileInput.click()"
      (keydown.enter)="fileInput.click()"
      (keydown.space)="fileInput.click()"
      tabindex="0">
  @if (error) {
    <div class="common-error">
      <img src="icons/error_icon.png" alt="error">
      Произошла ошибка при загрузке изображения: {{ error }}
    </div>
  }
  <input
    #fileInput
    type="file"
    (change)="onFileSelected($event)"
    accept="image/*"
    class="file-input"
    style="display: none;">
</div>

